import jwtDecode from 'jwt-decode'
import Cookies from './cookies'

export const JWT_PUBLISHER = 'publisher_token'
export const JWT_PUBLISHER_TYPE = 'publisher'
let jwt_token = {
  key: '',
  type: JWT_PUBLISHER_TYPE,
}

export const getCurrentUser = () => {
  const tokenByPublisher = Cookies.get(JWT_PUBLISHER)
  let currentUser = {}
  try {
    if (tokenByPublisher) {
      jwt_token = {
        key: tokenByPublisher,
        type: JWT_PUBLISHER_TYPE,
      }
      return {
        ...jwtDecode(tokenByPublisher),
        isPublisher: true,
        accessToken: tokenByPublisher,
      }
    }
  } finally {
  }
  return currentUser
}

export const setUserToken = token => {
  jwt_token.key = token
  jwt_token.type = JWT_PUBLISHER_TYPE
  Cookies.set(JWT_PUBLISHER, token)
}

export const isHaveUser = () => {
  return Cookies.get(JWT_PUBLISHER)
}

export const getUserToken = () => {
  return jwt_token.key
}

export const isUser = user => {
  return user && user.accessToken
}
